import React from "react";
import OrHighlight from "../../../components/OrHighlight";

export default function Highlight(props) {
  return <OrHighlight {...props} />;
}
